// extracted by mini-css-extract-plugin
export default {"storyTimeline":"c-a_gs","storyTimeline__item":"c-a_gt","storyTimeline__item_complete":"c-a_gu","storyTimeline__item_withProgress":"c-a_gv"};